module.exports = __webpack_public_path__ + "img/honorable.e72d40af.png";